import { render, staticRenderFns } from "./editPDF.vue?vue&type=template&id=38423004"
import script from "./editPDF.vue?vue&type=script&lang=js"
export * from "./editPDF.vue?vue&type=script&lang=js"
import style0 from "./editPDF.vue?vue&type=style&index=0&id=38423004&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports